import { RadioInputController } from './radio-input.controller'

const component = {
  templateUrl: '/workflow/components/radio-input/radio-input.html?$$REVISION$$',
  bindings: {
    field: '<',
    readOnly: '<',
    variations: '<', // space-delimited
    onChange: '&'
  },
  controllerAs: '$ctrl',
  controller: RadioInputController
}

export const radioInput = component
